// // src/pages/Bookings.js
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import {
//   Container,
//   Table,
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   FormGroup,
//   Input,
// } from 'reactstrap';
// import BookingForm from '../components/BookingForm';
// import ReturnProduct from '../components/ReturnProduct';

// const Bookings = () => {
//   const [bookings, setBookings] = useState([]);
//   const [bookingModalOpen, setBookingModalOpen] = useState(false);
//   const [returnModalOpen, setReturnModalOpen] = useState(false);
//   const [confirmModalOpen, setConfirmModalOpen] = useState(false);
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [newStatus, setNewStatus] = useState('');

//   const fetchBookings = async () => {
//     try {
//       const response = await axios.get('/api/bookings');
//       setBookings(response.data);
//     } catch (err) {
//       console.error('Error fetching bookings:', err);
//     }
//   };

//   useEffect(() => {
//     fetchBookings();
//   }, []);

//   const handleStatusChange = (booking, status) => {
//     setSelectedBooking(booking);
//     setNewStatus(status);
//     setConfirmModalOpen(true);
//   };

//   const confirmStatusUpdate = async () => {
//     try {
//       await axios.put(`/api/bookings/${selectedBooking.id}/status`, {
//         status: newStatus,
//       });
//       setConfirmModalOpen(false);
//       fetchBookings();
//     } catch (err) {
//       console.error('Status update failed:', err);
//       alert('Failed to update status.');
//     }
//   };

//   return (
//     <Container className="py-4">
//       <h1 className="text-center mb-4">Booking List</h1>
//       <div className="mb-3">
//         <Button
//           color="primary"
//           className="me-2"
//           onClick={() => setBookingModalOpen(true)}
//         >
//           New Booking
//         </Button>
//       </div>

//       <Table bordered hover responsive>
//         <thead>
//           <tr>
//             <th>ID</th>
//             <th>Product</th>
//             <th>Customer</th>
//             <th>Quantity</th>
//             <th>Booking Date</th>
//             <th>Dispatch Date</th>
//             <th>Return Date</th>
//             <th>Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {bookings.length === 0 ? (
//             <tr>
//               <td colSpan="8" className="text-center">
//                 No bookings available.
//               </td>
//             </tr>
//           ) : (
//             bookings.map((b) => (
//               <tr key={b.id}>
//                 <td>{b.id}</td>
//                 <td>{b.product_name}</td>
//                 <td>{b.customer_name}</td>
//                 <td>{b.quantity}</td>
//                 <td>{b.booking_date}</td>
//                 <td>{b.dispatch_date || '—'}</td>
//                 <td>{b.return_date || '—'}</td>
//                 <td>
//                   {b.status === 'Returned' ? (
//                     <span>{b.status}</span>
//                   ) : (
//                     <FormGroup className="mb-0">
//                       <Input
//                         type="select"
//                         value={b.status}
//                         onChange={(e) => {
//                           const selected = e.target.value;
//                           if (selected !== b.status) {
//                             handleStatusChange(b, selected);
//                           }
//                         }}
//                       >
//                         <option value={b.status}>{b.status}</option>
//                         {b.status === 'Booked' && (
//                           <option value="Dispatched">Dispatched</option>
//                         )}
//                         {b.status === 'Dispatched' && (
//                           <option value="Returned">Returned</option>
//                         )}
//                       </Input>
//                     </FormGroup>
//                   )}
//                 </td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </Table>

//       {/* New Booking Modal */}
//       <Modal isOpen={bookingModalOpen} toggle={() => setBookingModalOpen(false)}>
//         <ModalHeader toggle={() => setBookingModalOpen(false)}>New Booking</ModalHeader>
//         <ModalBody>
//           <BookingForm
//             onBook={fetchBookings}
//             closeModal={() => setBookingModalOpen(false)}
//           />
//         </ModalBody>
//       </Modal>

//       {/* Return Product Modal */}
//       <Modal isOpen={returnModalOpen} toggle={() => setReturnModalOpen(false)}>
//         <ModalBody>
//           <ReturnProduct
//             onReturn={fetchBookings}
//             closeModal={() => setReturnModalOpen(false)}
//           />
//         </ModalBody>
//       </Modal>

//       {/* Status Confirmation Modal */}
//       <Modal isOpen={confirmModalOpen} toggle={() => setConfirmModalOpen(false)}>
//         <ModalHeader toggle={() => setConfirmModalOpen(false)}>
//           Confirm Status Change
//         </ModalHeader>
//         <ModalBody>
//           Are you sure you want to change the status from <b>{selectedBooking?.status}</b> to{' '}
//           <b>{newStatus}</b>?
//         </ModalBody>
//         <ModalFooter>
//           <Button color="primary" onClick={confirmStatusUpdate}>
//             Confirm
//           </Button>{' '}
//           <Button color="secondary" onClick={() => setConfirmModalOpen(false)}>
//             Cancel
//           </Button>
//         </ModalFooter>
//       </Modal>
//     </Container>
//   );
// };

// export default Bookings;



import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import axios from '../api';
// Material-UI imports
import {
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Select,
  MenuItem,
  Typography,
  IconButton,
  Box,
  InputLabel,
  FormControl,
  TextField,
  InputAdornment,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ListPagination, { useListPagination } from '../components/ui/ListPagination';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ReplayIcon from '@mui/icons-material/Replay';
import ListIcon from '@mui/icons-material/List';
import SearchIcon from '@mui/icons-material/Search';
import BookingForm from '../components/BookingForm';
import BookingEditModal from '../components/BookingEditModal';
import { ToastProvider, useToast } from '../components/ToastProvider';
import { formatDate } from '../utils/dateUtils';
import { useUser } from '../components/UserContext';
import { openOrDownloadPdf } from '../utils/generatePdf';
import PageHeader from '../components/ui/PageHeader';
import ContentCard from '../components/ui/ContentCard';
import StatusBadge from '../components/ui/StatusBadge';
import PageLoader from '../components/ui/PageLoader';
import SortableTableHeader from '../components/ui/SortableTableHeader';
import { sortItems, toggleSort } from '../utils/tableSort';
import { bookingMatchesSearch } from '../utils/searchUtils';
import {
  pageContainerSx,
  tableHeaderSx,
  customerNameSx,
  dateTextSx,
  dateTodaySx,
  filterFieldSx,
  segmentControlSx,
  segmentButtonSx,
  segmentCountSx,
} from '../styles/tokens';

const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const TABS = [
  { key: 'dispatch_today', label: 'Dispatch Today', icon: LocalShippingIcon },
  { key: 'returns_today', label: 'Returns Today', icon: ReplayIcon },
  { key: 'all', label: 'All Bookings', icon: ListIcon },
];

const VALID_TABS = new Set(TABS.map((t) => t.key));
const VALID_STATUSES = new Set(['ALL', 'ORDERED', 'DISPATCHED', 'RECEIVED', 'CANCELLED']);

const Bookings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { user } = useUser();
  const isWarehouse = (user?.role || '').toString().toLowerCase() === 'warehouse';
  const [bookings, setBookings] = useState([]);
  const searchTerm = searchParams.get('q') || '';
  const activeTab = VALID_TABS.has(searchParams.get('tab')) ? searchParams.get('tab') : 'all';
  const statusFilter = VALID_STATUSES.has(searchParams.get('status')) ? searchParams.get('status') : 'ALL';
  const [editStatusId, setEditStatusId] = useState(null);
  const [newStatus, setNewStatus] = useState('');
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [editBookingModal, setEditBookingModal] = useState(false);
  const [editBookingData, setEditBookingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const showToast = useToast();
  const [sortBy, setSortBy] = useState('id');
  const [sortDir, setSortDir] = useState('desc');

  const updateListParams = useCallback((updates, { replace = true } = {}) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      Object.entries(updates).forEach(([key, value]) => {
        const clearDefault =
          (key === 'q' && !value) ||
          (key === 'tab' && (!value || value === 'all')) ||
          (key === 'status' && (!value || value === 'ALL'));
        if (clearDefault) next.delete(key);
        else next.set(key, String(value));
      });
      return next;
    }, { replace });
  }, [setSearchParams]);

  const setSearchTerm = (value) => updateListParams({ q: value });
  const setActiveTab = (tab) => updateListParams({ tab });
  const setStatusFilter = (status) => updateListParams({ status });

  const openBookingDetails = (id) => {
    const fromBookings = `${location.pathname}${location.search}`;
    navigate(`/bookings/${id}`, { state: { fromBookings } });
  };

  const today = todayStr();

  const tabCounts = useMemo(() => ({
    dispatch_today: bookings.filter((b) => b.dispatch_date === today).length,
    returns_today: bookings.filter((b) => b.return_date === today).length,
    all: bookings.length,
  }), [bookings, today]);

  const handleSort = (column) => {
    const next = toggleSort(sortBy, sortDir, column);
    setSortBy(next.sortBy);
    setSortDir(next.sortDir);
  };

  const filteredBookings = useMemo(() => {
    let list = bookings;
    if (activeTab === 'dispatch_today') {
      list = list.filter((b) => b.dispatch_date === today);
    } else if (activeTab === 'returns_today') {
      list = list.filter((b) => b.return_date === today);
    }
    list = list.filter((b) => bookingMatchesSearch(b, searchTerm));
    return sortItems(list, sortBy, sortDir);
  }, [bookings, activeTab, today, searchTerm, sortBy, sortDir]);

  const {
    paginatedItems: paginatedBookings,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    totalCount,
  } = useListPagination(filteredBookings, [activeTab, statusFilter, searchTerm, sortBy, sortDir, bookings.length]);

  // Warehouse may only transition: ORDERED -> DISPATCHED, DISPATCHED -> RECEIVED
  const allowedNextStatusesForWarehouse = (current) => {
    if (current === 'ORDERED') return ['DISPATCHED'];
    if (current === 'DISPATCHED') return ['RECEIVED'];
    return [];
  };

  const fetchBookings = async (status = statusFilter) => {
    setLoading(true);
    try {
      const params = {};
      if (status && status !== 'ALL') {
        params.status = status;
      }
      const res = await axios.get('/api/bookings', { params });
      setBookings(res.data);
    } catch (error) {
      showToast('Error fetching bookings', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings(statusFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startEditStatus = (id, currentStatus) => {
    setEditStatusId(id);
    setNewStatus(currentStatus);
  };

  const cancelEditStatus = () => {
    setEditStatusId(null);
    setNewStatus('');
  };

  const saveStatus = async (id) => {
    try {
      console.log(id)
      await axios.patch(`/api/bookings/${id}/status`, { status: newStatus });
      fetchBookings();
      cancelEditStatus();
      showToast('Status updated successfully', 'success');
    } catch (error) {
      showToast('Failed to update status', 'error');
    }
  };

  // Handler to open edit modal and load booking details
  const openEditBooking = async (id) => {
    try {
      const res = await axios.get(`/api/bookings/${id}`);
      setEditBookingData(res.data);
      setEditBookingModal(true);
    } catch (error) {
      console.error('Error fetching booking for edit:', error);
    }
  };

  // Handler to close edit modal
  const closeEditBooking = () => {
    setEditBookingModal(false);
    setEditBookingData(null);
  };

  // Handler to submit updated booking
  const handleEditBookingSubmit = async (updatedData) => {
    try {
      await axios.patch(`/api/bookings/${editBookingData.id}`, updatedData);
      closeEditBooking();
      fetchBookings();
      showToast('Booking updated successfully', 'success');
    } catch (error) {
      showToast('Failed to update booking', 'error');
    }
  };

  const openBookingPdf = async (groupId) => {
    try {
      const res = await axios.get(`/api/bookings/${groupId}/pdf`, { responseType: 'blob' });
      const blob = new Blob([res.data], { type: 'application/pdf' });
      openOrDownloadPdf(blob, `booking-${groupId}.pdf`);
    } catch (error) {
      showToast(error.response?.data?.message || 'Failed to generate PDF', 'error');
    }
  };

  const canCancelBooking = (booking) =>
    !isWarehouse && booking.status === 'ORDERED';

  const handleCancelBooking = async (booking) => {
    if (!canCancelBooking(booking)) return;
    const label = `#${booking.id}${booking.customer ? ` (${booking.customer})` : ''}`;
    if (!window.confirm(`Cancel booking ${label}? The order will be marked as cancelled.`)) return;
    try {
      await axios.patch(`/api/bookings/${booking.id}/status`, { status: 'CANCELLED' });
      showToast('Booking cancelled successfully', 'success');
      fetchBookings();
    } catch (error) {
      showToast(error.response?.data?.error || 'Failed to cancel booking', 'error');
    }
  };

  const deleteButtonSx = {
    width: 28,
    height: 28,
    color: 'text.secondary',
    borderRadius: 1.25,
    '&:hover': { bgcolor: 'error.light', color: 'error.main' },
    '&.Mui-disabled': { opacity: 0.4 },
  };

  return (
    <Box sx={pageContainerSx}>
      <PageHeader
        title="Bookings"
        subtitle="Manage orders, dispatch schedules, and returns"
        actionLabel={!isWarehouse ? 'New Booking' : undefined}
        actionIcon={<AddIcon sx={{ fontSize: 16 }} />}
        onAction={!isWarehouse ? () => setShowBookingForm(true) : undefined}
      />

      {/* Tabs + status filter */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
        <Box sx={segmentControlSx}>
          {TABS.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.key;
            const count = tabCounts[tab.key];
            return (
              <Button
                key={tab.key}
                size="small"
                variant="text"
                onClick={() => setActiveTab(tab.key)}
                startIcon={<Icon sx={{ fontSize: 16, color: isActive ? 'primary.main' : 'text.secondary' }} />}
                sx={segmentButtonSx(isActive)}
              >
                {tab.label}
                <Typography component="span" sx={segmentCountSx(isActive)}>
                  {count}
                </Typography>
              </Button>
            );
          })}
        </Box>
        <FormControl size="small" sx={{ width: { xs: '100%', sm: 140 }, minWidth: 120 }}>
          <InputLabel id="status-filter-label" sx={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Status</InputLabel>
          <Select
            labelId="status-filter-label"
            value={statusFilter}
            label="Status"
            onChange={(e) => {
              const value = e.target.value;
              setStatusFilter(value);
              fetchBookings(value);
            }}
            sx={{ height: 36, fontSize: '0.8125rem', borderRadius: 2, bgcolor: 'background.paper', '& .MuiSelect-select': { py: 0.75 }, '& fieldset': { borderColor: 'divider' } }}
          >
            <MenuItem value="ALL">All</MenuItem>
            <MenuItem value="ORDERED">Ordered</MenuItem>
            <MenuItem value="DISPATCHED">Dispatched</MenuItem>
            <MenuItem value="RECEIVED">Received</MenuItem>
            <MenuItem value="CANCELLED">Cancelled</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <TextField
        placeholder="Search by order ID, customer, company, dates, amount, status..."
        size="small"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ width: '100%', maxWidth: { xs: '100%', sm: 400 }, ...filterFieldSx }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" sx={{ mr: 0.5 }}>
              <SearchIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
            </InputAdornment>
          ),
        }}
      />

      {showBookingForm && (
        <BookingForm
          closeModal={() => {
            setShowBookingForm(false);
            fetchBookings();
          }}
        />
      )}

      <ContentCard sx={{ width: '100%', minWidth: 0 }}>
        {loading ? (
          <PageLoader variant="section" message="Loading bookings..." />
        ) : isMobile ? (
          /* Mobile card view */
          <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            {filteredBookings.length === 0 ? (
              <Typography sx={{ textAlign: 'center', py: 4, fontSize: '0.875rem', color: 'text.secondary' }}>
                No bookings found
              </Typography>
            ) : (
              paginatedBookings.map((b) => {
                return (
                  <Paper
                    key={b.id}
                    elevation={0}
                    sx={{
                      borderRadius: 2,
                      border: '1px solid',
                      borderColor: 'divider',
                      overflow: 'hidden',
                      bgcolor: 'background.paper',
                    }}
                  >
                    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                      {/* Card header: Order #, Customer, Company, Status */}
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                          <Typography component="span" sx={{ fontFamily: 'monospace', fontSize: '0.75rem', fontWeight: 600, color: 'text.primary' }}>
                            #{b.id}
                          </Typography>
                          <Button
                            variant="text"
                            size="small"
                            onClick={() => openBookingDetails(b.id)}
                            sx={customerNameSx}
                          >
                            {b.customer}
                          </Button>
                          {(b.company_name || '') !== '' && b.company_name !== '—' && (
                            <Typography component="span" sx={{ fontSize: '0.6875rem', color: 'text.secondary' }}>
                              · {b.company_name}
                            </Typography>
                          )}
                        </Box>
                        <StatusBadge status={b.status} />
                      </Box>
                      {/* Date grid: Booked, Dispatch, Return */}
                      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 1.5 }}>
                        <Box>
                          <Typography sx={{ fontSize: '0.6875rem', color: 'text.secondary', mb: 0.25 }}>Booked</Typography>
                          <Typography sx={{ ...dateTextSx }}>{formatDate(b.booking_date)}</Typography>
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: '0.6875rem', color: 'text.secondary', mb: 0.25 }}>Dispatch</Typography>
                          <Typography sx={{ ...dateTextSx, ...(b.dispatch_date === today ? dateTodaySx : {}) }}>
                            {formatDate(b.dispatch_date)}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography sx={{ fontSize: '0.6875rem', color: 'text.secondary', mb: 0.25 }}>Return</Typography>
                          <Typography sx={{ ...dateTextSx, ...(b.return_date === today ? dateTodaySx : {}) }}>
                            {formatDate(b.return_date) || '—'}
                          </Typography>
                        </Box>
                      </Box>
                      {/* Footer: Amount + Actions */}
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: isWarehouse ? 'flex-end' : 'space-between', pt: 1, borderTop: '1px solid', borderColor: 'divider' }}>
                        {!isWarehouse && (
                          <Typography sx={{ fontSize: '0.875rem', fontFamily: 'monospace', fontWeight: 600, color: 'text.primary' }}>
                            ₹{b.total_amount}
                          </Typography>
                        )}
                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                          <IconButton size="small" onClick={() => openBookingDetails(b.id)} sx={{ width: 32, height: 32, color: 'text.secondary', '&:hover': { bgcolor: 'action.hover', color: 'primary.main' } }} title="View">
                            <VisibilityIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          <IconButton size="small" onClick={() => openBookingPdf(b.id)} sx={{ width: 32, height: 32, color: 'text.secondary', '&:hover': { bgcolor: 'action.hover', color: 'primary.main' } }} title="PDF">
                            <PictureAsPdfIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                          {!isWarehouse && (
                            <IconButton size="small" onClick={() => openEditBooking(b.id)} sx={{ width: 32, height: 32, color: 'text.secondary', '&:hover': { bgcolor: 'action.hover', color: 'primary.main' } }} title="Edit">
                              <EditIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                          )}
                          {canCancelBooking(b) && (
                            <IconButton
                              size="small"
                              onClick={() => handleCancelBooking(b)}
                              sx={{ width: 32, height: 32, color: 'text.secondary', '&:hover': { bgcolor: 'error.light', color: 'error.main' } }}
                              title="Cancel booking"
                            >
                              <DeleteIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                );
              })
            )}
          </Box>
        ) : (
            <TableContainer sx={{ overflowX: 'auto' }}>
              <Table size="small" sx={{ minWidth: 700 }}>
                <TableHead>
                  <TableRow sx={{ bgcolor: 'action.hover' }}>
                    <SortableTableHeader label="Order ID" column="id" sortBy={sortBy} sortDir={sortDir} onSort={handleSort} minWidth={80} />
                    <SortableTableHeader label="Customer" column="customer" sortBy={sortBy} sortDir={sortDir} onSort={handleSort} minWidth={120} />
                    <SortableTableHeader label="Company" column="company_name" sortBy={sortBy} sortDir={sortDir} onSort={handleSort} minWidth={110} />
                    <SortableTableHeader label="Booking Date" column="booking_date" sortBy={sortBy} sortDir={sortDir} onSort={handleSort} minWidth={110} />
                    <SortableTableHeader label="Dispatch Date" column="dispatch_date" sortBy={sortBy} sortDir={sortDir} onSort={handleSort} minWidth={110} />
                    <SortableTableHeader label="Return Date" column="return_date" sortBy={sortBy} sortDir={sortDir} onSort={handleSort} minWidth={110} />
                    {!isWarehouse && (
                      <SortableTableHeader label="Amount" column="total_amount" sortBy={sortBy} sortDir={sortDir} onSort={handleSort} minWidth={90} />
                    )}
                    <SortableTableHeader label="Status" column="status" sortBy={sortBy} sortDir={sortDir} onSort={handleSort} minWidth={100} />
                    <TableCell align="center" sx={{ ...tableHeaderSx, width: 140 }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredBookings.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={isWarehouse ? 8 : 9} align="center" sx={{ py: 6, color: 'text.secondary' }}>
                        No bookings found
                      </TableCell>
                    </TableRow>
                  ) : (
                    paginatedBookings.map((b) => {
                      return (
                        <TableRow
                          key={b.id}
                          sx={{
                            '&:hover': { bgcolor: 'action.hover' },
                            '&:hover .actions-buttons': { opacity: 1 },
                            transition: 'background-color 0.15s',
                          }}
                        >
                          <TableCell sx={{ px: 2, py: 1.5 }}>
                            <Typography component="span" sx={{ fontSize: '0.9375rem', color: 'text.primary' }}>
                              #{b.id}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ px: 2, py: 1.5 }}>
                            <Button
                              variant="text"
                              size="small"
                              onClick={() => openBookingDetails(b.id)}
                              sx={customerNameSx}
                            >
                              {b.customer}
                            </Button>
                          </TableCell>
                          <TableCell sx={{ px: 2, py: 1.5, fontSize: '0.9375rem', color: 'text.secondary' }}>{b.company_name || '—'}</TableCell>
                          <TableCell sx={{ px: 2, py: 1.5 }}>
                            <Typography component="span" sx={dateTextSx}>{formatDate(b.booking_date)}</Typography>
                          </TableCell>
                          <TableCell sx={{ px: 2, py: 1.5 }}>
                            <Typography component="span" sx={{ ...dateTextSx, ...(b.dispatch_date === today ? dateTodaySx : {}) }}>
                              {formatDate(b.dispatch_date)}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ px: 2, py: 1.5 }}>
                            <Typography component="span" sx={{ ...dateTextSx, ...(b.return_date === today ? dateTodaySx : {}) }}>
                              {formatDate(b.return_date) || '—'}
                            </Typography>
                          </TableCell>
                          {!isWarehouse && (
                            <TableCell sx={{ px: 2, py: 1.5 }}>
                              <Typography component="span" sx={{ fontSize: '0.9375rem', color: 'text.primary' }}>
                                ₹{b.total_amount}
                              </Typography>
                            </TableCell>
                          )}
                          <TableCell sx={{ px: 2, py: 1.5 }}>
                            <StatusBadge status={b.status} />
                          </TableCell>
                          <TableCell align="center" sx={{ px: 2, py: 1.5 }}>
                            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
                              <IconButton
                                size="small"
                                onClick={(e) => { e.stopPropagation(); openBookingDetails(b.id); }}
                                sx={{
                                  width: 28,
                                  height: 28,
                                  color: 'text.secondary',
                                  borderRadius: 1.25,
                                  '&:hover': { bgcolor: 'action.hover', color: 'primary.main' },
                                }}
                                title="View details"
                              >
                                <VisibilityIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                              <IconButton
                                size="small"
                                onClick={(e) => { e.stopPropagation(); openBookingPdf(b.id); }}
                                sx={{
                                  width: 28,
                                  height: 28,
                                  color: 'text.secondary',
                                  borderRadius: 1.25,
                                  '&:hover': { bgcolor: 'action.hover', color: 'primary.main' },
                                }}
                                title="Export PDF"
                              >
                                <PictureAsPdfIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                              {!isWarehouse && (
                                <IconButton
                                  size="small"
                                  onClick={(e) => { e.stopPropagation(); openEditBooking(b.id); }}
                                  sx={{
                                    width: 28,
                                    height: 28,
                                    color: 'text.secondary',
                                    borderRadius: 1.25,
                                    '&:hover': { bgcolor: 'action.hover', color: 'primary.main' },
                                  }}
                                  title="Edit"
                                >
                                  <EditIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                              )}
                              {canCancelBooking(b) && (
                                <IconButton
                                  size="small"
                                  onClick={(e) => { e.stopPropagation(); handleCancelBooking(b); }}
                                  sx={deleteButtonSx}
                                  title="Cancel booking"
                                >
                                  <DeleteIcon sx={{ fontSize: 16 }} />
                                </IconButton>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
        )}
        {!loading && (
          <ListPagination
            page={page}
            totalCount={totalCount}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            itemLabel="booking"
          />
        )}
      </ContentCard>

      <BookingEditModal
        isOpen={editBookingModal}
        booking={editBookingData}
        onClose={closeEditBooking}
        onSubmit={handleEditBookingSubmit}
      />
    </Box>
  );
};

export default Bookings;
